import React, { useState } from 'react';
import { AuthScreen } from './AuthScreen';
import { Dashboard } from './Dashboard';
import CompanyApp from './CompanyApp'; // Jouw bestaande company frontend bestand
import CandidateApp from './CandidateApp'; // Je bestaande candidate bestand
import { useTranslation, normalizeLanguage } from './i18n';

export default function MainPlatform({ userType, apiBase, onLogout, onBackToHome }) { // <--- Props toevoegen
  const [user, setUser] = useState(null);
  const [view, setView] = useState('dashboard');
  const { setLanguage } = useTranslation();

  // Handler als login/registratie succesvol is
  const handleLogin = (userData) => {
    setUser(userData);

    // Sync taalvoorkeur uit user-record (backend heeft de bron van waarheid
    // wanneer de user al bestaat). Ontbreekt de voorkeur of is die ongeldig
    // dan behouden we de huidige (uit localStorage/browser afgeleide) taal.
    const preferred = normalizeLanguage(userData?.language_preference);
    if (preferred) setLanguage(preferred);

    // Logica: als het een nieuwe user is (progress < 100), ga direct naar onboarding?
    // Of altijd eerst dashboard? Laten we dashboard doen voor het overzicht.
    setView('dashboard');
  };

  const handleLogout = () => {
    setUser(null);
    setView('dashboard');
  };

  // Render logica
if (!user) {
    return (
        <AuthScreen 
            apiBase={apiBase}         // <--- BELANGRIJK: Doorweven naar Auth
            defaultType={userType}    // <--- Zodat talent gelijk op 'kandidaat' staat
            onLogin={handleLogin} 
        />
    );
  }

  if (view === 'onboarding') {
    // Hier injecteren we de user data in de bestaande apps!
    // Belangrijk: De bestaande apps moeten we straks aanpassen zodat ze 
    // personalia als prop accepteren ipv stap 1 te tonen.
    if (user.type === 'company') {
        return (
            <CompanyApp 
                apiBase={apiBase} // Zorg dat CompanyApp deze prop gebruikt ipv hardcoded URL!
                userId={user.id} 
                initialPersonalia={user.personalia} 
                initialStep={user.progress?.step || 1}
                onBackToDashboard={() => setView('dashboard')}
            />
        );
    } else {
        return (
            <CandidateApp 
                apiBase={apiBase} // Zorg dat CandidateApp deze prop gebruikt ipv hardcoded URL!
                userId={user.id}
                initialPersonalia={user.personalia}
                initialStep={user.progress?.step || 1}
                onBackToDashboard={() => setView('dashboard')}
            />
        );
    }
  }

  // Default: Dashboard
  return (
    <Dashboard 
        user={user} 
        onLogout={handleLogout}
        onStartOnboarding={() => setView('onboarding')}
        onResumeOnboarding={() => setView('onboarding')}
        apiBase={apiBase}
        onBackToHome={onBackToHome}
    />
  );
}